import dayjs from "dayjs";
import { BaseAction } from "../../../core/actions/BaseAction";
import { convertPassengersToCount, determinePassengerType, formatDate, getNextDaysForBookReturnJourney, getPassengerAge, isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingResponse } from "../../../Orchestrator/Types/Interface/IBooking";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { getSearchSelectedPassenger } from "../../../Lib/Utils/passenger";
import { getSearchResultAction } from "../../LogicActions/Search/GetSearchResultAction";
import { preferTrainTrips } from "../../../Lib/Utils/booking";

export class BookReturnJourneyContinueClickAction extends BaseAction<IDefaultActionResult, {
    redirectPath: string,
    selectedRange: [dayjs.Dayjs | null, dayjs.Dayjs | null],
    booking: IBookingResponse,
    selectedPassengerForCancel: string[],
    selectedDate: dayjs.Dayjs,
}> {
    override async run(): Promise<IDefaultActionResult> {
        const { redirectPath, selectedRange, booking, selectedPassengerForCancel, selectedDate } = this.params!;
        let result: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        updateRecoilState("trainAtom", null);
        updateRecoilState("selectedPassengerForCancelAtom", null);
        updateRecoilState("selectedPassengerForCancelInBoundAtom", null);
        updateRecoilState("selectedPassengerForCancelAtom", selectedPassengerForCancel);
        updateRecoilState("selectedPassengerForCancelInBoundAtom", selectedPassengerForCancel);
        updateRecoilState("selectedOutboundTrainAtom", null);
        updateRecoilState("selectedInboundTrainAtom", null);
        updateRecoilState("tripLegsDetailsAtom", {
            outbound: {},
            inbound: {}
        });
        updateRecoilState("selectedTrainLegsAtom", {
            outbound: [],
            inbound: []
        });

        updateRecoilState("trainTypeAtom", TrainTypeEnum.inbound);

        try {
            console.log("booking", booking);
            const anonymousPassengerSpecifications =
                booking?.booking?.passengers.filter(p =>
                    selectedPassengerForCancel.includes(p.id)
                ).map((passenger) => ({
                    id: passenger.id,
                    type: passenger.type,
                    externalRef: passenger.externalRef,
                    age: passenger.age >= 3 && passenger.age <= 11 ? 3 :
                        passenger.age >= 0 && passenger.age <= 2 ? 1 :
                            passenger.age,
                    cards: passenger?.cards || [],
                    prmNeeds: passenger?.prmNeeds || [],
                    sharePlaceWithGuardian: passenger.age >= 0 && passenger.age <= 2 ? true : undefined,
                    detail: passenger.detail || ""
                })) || [];
            console.log("anonymousPassengerSpecifications", anonymousPassengerSpecifications);
            const passengers = convertPassengersToCount(anonymousPassengerSpecifications);
            const {
                totalPassengerCount,
                passengerCounts,
            } = getSearchSelectedPassenger(passengers);

            // The return journey mirrors the TRAIN trip. trips[0] can be a
            // standalone onward-shuttle trip (sorts first), whose stops are bus
            // stops — searching them returns TRIP_NO_SEARCH_RESULT.
            const returnBaseTrip = preferTrainTrips(booking?.booking?.trips)[0];
            const searchParams = {
                fromName: returnBaseTrip?.destination,
                toName: returnBaseTrip?.origin,
                departureTime: selectedDate.format("YYYY-MM-DDTHH:mm:ss"),
                arrivalTime: returnBaseTrip?.startTime,
                origin: returnBaseTrip?.destination?.stopPlaceRef,
                destination: returnBaseTrip?.origin?.stopPlaceRef,
                totalPassengerCount: totalPassengerCount,
                passengerCounts: passengerCounts,
                trainType: TrainTypeEnum.inbound,
                selectedTrain: undefined,
                selectedTripPassenger: anonymousPassengerSpecifications,
                isFromBookReturnJourney: true,
                passengers: passengers
            };
            updateRecoilState("inboundSearchStateAtom", searchParams);
            const filteredBookingPassengers = booking.booking?.passengers.filter(p => selectedPassengerForCancel.includes(p.id)) || [];
            updateRecoilState("passengerStateAtom", null)
            updateRecoilState("passengerStateAtom", filteredBookingPassengers);
            updateRecoilState("availableDatesAtom", getNextDaysForBookReturnJourney(selectedDate.toISOString()));
            getSearchResultAction.setParams(searchParams);
            await getSearchResultAction.execute();

            // if (isActionRunSuccessfully(getSearchResultAction)) {
            //     const fetchResult: IDefaultActionResult = getSearchResultAction.result!
            //     if (fetchResult.status == "success") {
            result.status = "success"
            // }
            // }

        } catch (error) {
            console.error("Error fetching exchange offers:", error);
            result.status = "fail"
        }
        finally {
            return result;
        }
    }
}

export const bookReturnJourneyContinueClickAction = new BookReturnJourneyContinueClickAction();